import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo/banner.png'


const _withScopeId = n => (_pushScopeId("data-v-03f8708a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module-list-content" }
const _hoisted_2 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_3 = { class: "presented-footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_menu = _resolveComponent("event-menu")!
  const _component_main_header = _resolveComponent("main-header")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_description_module = _resolveComponent("description-module")!
  const _component_date_module = _resolveComponent("date-module")!
  const _component_discuss_module = _resolveComponent("discuss-module")!
  const _component_vote_module = _resolveComponent("vote-module")!
  const _component_checklist_module = _resolveComponent("checklist-module")!
  const _component_map_module = _resolveComponent("map-module")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_content_filter = _resolveComponent("content-filter")!
  const _component_userlist_module = _resolveComponent("userlist-module")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_event_menu),
      (_ctx.EventService.data.event !== undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_main_header, {
              title: _ctx.EventService.data.event.static.title,
              onOpenMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenu())),
              onShowShare: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showShare($event)))
            }, null, 8, ["title"]),
            _createVNode(_component_ion_progress_bar, {
              type: "indeterminate",
              class: _normalizeClass(["loading-bar", { hidden: !_ctx.WebSocketClientService.status.loading }])
            }, null, 8, ["class"]),
            _createVNode(_component_ion_content, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (!_ctx.WebSocketClientService.status.online)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (!_ctx.WebSocketClientService.status.online)
                          ? (_openBlock(), _createBlock(_component_ion_chip, {
                              key: 0,
                              class: "ion-padding offline-mark",
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.warningOutline }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.lang.t("offline")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_content_filter, { small: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-wrap ion-justify-content-center" }, {
                        default: _withCtx(() => [
                          (_ctx.EventService.data.event.static.modules.description)
                            ? (_openBlock(), _createBlock(_component_description_module, {
                                key: 0,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.date)
                            ? (_openBlock(), _createBlock(_component_date_module, {
                                key: 1,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.discuss)
                            ? (_openBlock(), _createBlock(_component_discuss_module, {
                                key: 2,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.vote)
                            ? (_openBlock(), _createBlock(_component_vote_module, {
                                key: 3,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.checklist)
                            ? (_openBlock(), _createBlock(_component_checklist_module, {
                                key: 4,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.map)
                            ? (_openBlock(), _createBlock(_component_map_module, {
                                key: 5,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_content_filter, { medium: true }, {
                    default: _withCtx(() => [
                      (_ctx.EventService.data.event.static.modules.date)
                        ? (_openBlock(), _createBlock(_component_date_module, {
                            key: 0,
                            class: "big-module"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_row, { style: {"justify-content":"space-around"} }, {
                        default: _withCtx(() => [
                          (_ctx.EventService.data.event.static.modules.description)
                            ? (_openBlock(), _createBlock(_component_description_module, {
                                key: 0,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.discuss)
                            ? (_openBlock(), _createBlock(_component_discuss_module, {
                                key: 1,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.vote)
                            ? (_openBlock(), _createBlock(_component_vote_module, {
                                key: 2,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.checklist)
                            ? (_openBlock(), _createBlock(_component_checklist_module, {
                                key: 3,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.EventService.data.event.static.modules.map)
                            ? (_openBlock(), _createBlock(_component_map_module, {
                                key: 4,
                                class: "module-card"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_userlist_module),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.lang.t("presentedBy")), 1),
                  _hoisted_4
                ])
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}